import React from "react";
import { TextField, Box } from "@mui/material";
import { AdminTextFieldProps } from "../interfaces/auth.interface";
import themestyle from "../theme";

const AdminTextField: React.FC<AdminTextFieldProps> = ({
  name,
  label,
  value,
  onChange,
  isEditMode,
  error,
  helperText,
  required,
  type = "text",
  multiline,
  rows,
  disabled,
  onBlur,
}) => {
  return (
    <Box mt={2}>
      <Box
        sx={{
          fontSize: { xs: "12px", sm: "15px" },
          fontWeight: 500,
          mb: 0.6,
          fontFamily: themestyle.fontFamily.Roboto,
        }}
      >
        {label}
      </Box>
      <TextField
        fullWidth
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        type={type}
        multiline={multiline}
        rows={rows}
        error={!!error}
        helperText={error || helperText}
        disabled={disabled || !isEditMode}
        required={required && isEditMode}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            minHeight: { xs: "38px", sm: "44px" },
            "& input": {
              fontSize: { xs: "11px", sm: "14px" },
              padding: { xs: "12px", sm: "10px 12px" },
              fontFamily: themestyle.fontFamily.Roboto,
            },
            "& textarea": {
              fontSize: { xs: "12px", sm: "14px" },
              padding: "12px",
              fontFamily: themestyle.fontFamily.Roboto,
            },
            "&.Mui-focused fieldset": {
              borderColor: themestyle.colors.activeGreen,
              borderWidth: "1px",
            },
          },
          "& .MuiFormHelperText-root": {
            fontSize: { xs: "9px", sm: "12px" },
            marginLeft: "4px",
            fontFamily: themestyle.fontFamily.Roboto,
          },
        }}
        InputProps={{ readOnly: !isEditMode }}
      />
    </Box>
  );
};

export default AdminTextField;